import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {useRef} from 'react'
import useAtmosphere from '../../../hooks/useAtmosphere'
import {useEmbedUserAsset} from '../../../mutations/useEmbedUserAsset'
import {Button} from '../../../ui/Button/Button'





export const ImageSelectorEmbedTab = (props) => {
  const {setImageURL} = props
  const ref = useRef(null)
  const atmosphere = useAtmosphere()
  const [commit] = useEmbedUserAsset()
  const onSubmit = async (e) => {
    e.preventDefault()
    const url = _optionalChain([ref, 'access', _ => _.current, 'optionalAccess', _2 => _2.value])
    if (!url) return
    commit({
      variables: {url},
      onCompleted: (res) => {
        const {embedUserAsset} = res
        const {url} = embedUserAsset
        const message = _optionalChain([embedUserAsset, 'optionalAccess', _3 => _3.error, 'optionalAccess', _4 => _4.message])
        if (message) {
          atmosphere.eventEmitter.emit('addSnackbar', {
            key: 'errorEmbeddingAsset',
            message,
            autoDismiss: 5
          })
          return
        }
        setImageURL(url)
      }
    })
  }
  return (
    _jsxs('form', {
      className: "flex w-full min-w-44 flex-col items-center justify-center space-y-3 rounded-md bg-slate-100 p-2"         ,
      onSubmit: onSubmit,
 children: [
      _jsx('input', {
        autoComplete: "off",
        autoFocus: true,
        placeholder: "Paste the image link…"   ,
        type: "url",
        className: "w-full outline-hidden focus:ring-2"  ,
        ref: ref,}
      )
      , _jsx(Button, { variant: "outline", shape: "pill", className: "w-full", type: "submit", children: "Embed image"

      })
    ]})
  )
}
